export { MyPageContents, type MyPageContentsProps } from './MyPageContents';
